<template>
  <div class="confirmation-summary-row">
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <span class="label">{{label}}</span>
      </v-flex>
      <v-flex xs12 sm6 class="value">
        <slot />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/typography';
@import '../styles/vars/theme';

.confirmation-summary-row {
  padding: 10px 0;

  .label {
    color: $theme-color-gray;
    font-weight: $typography-weight-semibold;
  }

  .value {
    font-weight: $typography-weight-bold;
  }
}
</style>
